import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import {ProfileComponent} from './components/profile/profile.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import {RouterLink} from '@angular/router';
import { AvatarComponent } from "@shared/components/avatar/avatar.component";
import {CdkAccordion, CdkAccordionItem} from "@angular/cdk/accordion";



@NgModule({
  declarations: [
    HeaderComponent,
    ProfileComponent,
    BreadcrumbComponent
  ],
    imports: [
        CommonModule,
        RouterLink,
        AvatarComponent,
        CdkAccordion,
        CdkAccordionItem
    ],
    exports: [
        HeaderComponent,
        ProfileComponent,
    ]
})
export class HeaderModule { }
